import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { bolsas, bolsas_tipo, bolsas_tipo_unidade_novos, bolsas_tipo_unidade_renovados } from "../../services/api";

const Bolsas_pizza_detalhe = (props) => {

    const [data3, setData3] = useState([]);
    const [data4, setData4] = useState([]);
    const [data5, setData5] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;
    let filtro = props.filtro;


    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']


    const fetchData = async () => {
        try {
            const response3 = await bolsas_tipo(data_inicio, data_fim);
            setData3(response3.data);
            const response4 = await bolsas_tipo_unidade_novos(data_inicio, data_fim);
            setData4(response4.data);
            const response5 = await bolsas_tipo_unidade_renovados(data_inicio, data_fim);
            setData5(response5.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    let dadosdiltrados = []
    let dadosdiltrados2 = []

    if (typeof data3 !== 'undefined') {
        // dadosdiltrados = data3.filter(item => item.bolsas === filtro);
        dadosdiltrados2 = data3.map((item, index) => {
            const row = [item.bolsas];
            row.push(unidades[parseInt(item.sec)]);
            row.push(item.alunos || 0);
            row.push(parseFloat(item.bolsa_media));
            return row;
        });
    };
    dadosdiltrados2.unshift(['BOLSA', 'UNIDADE', 'ALUNOS', 'VLR MÉDIO']);

    let dataFiltradoNovos = []
    if (typeof data4 !== 'undefined') {
        // dadosdiltrados = data3.filter(item => item.bolsas === filtro);
        dataFiltradoNovos = data4.map((item, index) => {
            const row = [item.dsc];
            row.push(unidades[parseInt(item.sec)]);
            row.push(item.alunos || 0);
            row.push(parseFloat(item.vlr_medio));
            return row;
        });
    };
    dataFiltradoNovos.unshift(['BOLSA', 'UNIDADE', 'ALUNOS', 'VLR MÉDIO']);

    let dataFiltradoReno = []
    if (typeof data4 !== 'undefined') {
        // dadosdiltrados = data3.filter(item => item.bolsas === filtro);
        dataFiltradoReno = data5.map((item, index) => {
            const row = [item.dsc];
            row.push(unidades[parseInt(item.sec)]);
            row.push(item.alunos || 0);
            row.push(parseFloat(item.vlr_medio));
            return row;
        });
    };
    dataFiltradoReno.unshift(['BOLSA', 'UNIDADE', 'ALUNOS', 'VLR MÉDIO']);


    const options = {
        allowHtml: true,
        page: 'enable',
        pageSize: 15,


    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "BarFormat",
            column: 2,
            options: {
                width: 70,
                base: 0,
                max: 100,
                min: 0,
            },
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
    ];

    return (
        <div className="detalhes">
            <Tabs
                defaultActiveKey="Total"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="Total" title="Total">

                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={dadosdiltrados2}
                        options={options}
                        formatters={formatters}
                        chartWrapperParams={{ view: { columns: [0, 1, 2, 3] } }}
                        chartPackages={["corechart", "controls"]}
                        controls={[
                            {
                                controlEvents: [
                                    {
                                        eventName: "statechange",
                                        callback: ({ chartWrapper, controlWrapper }) => {
                                            console.log("State changed to", controlWrapper?.getState());
                                        },
                                    },
                                ],
                                controlType: "CategoryFilter",
                                options: {
                                    filterColumnIndex: 0,
                                    ui: {
                                        labelStacking: "vertical",
                                        label: "Bolsa",
                                        allowTyping: false,
                                        allowMultiple: true,
                                    },
                                },
                            },
                        ]}
                    />

                </Tab>
                <Tab eventKey="Novos" title="Novas">

                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={dataFiltradoNovos}
                        options={options}
                        formatters={formatters}
                        chartWrapperParams={{ view: { columns: [0, 1, 2, 3] } }}
                        chartPackages={["corechart", "controls"]}
                        controls={[
                            {
                                controlEvents: [
                                    {
                                        eventName: "statechange",
                                        callback: ({ chartWrapper, controlWrapper }) => {
                                            console.log("State changed to", controlWrapper?.getState());
                                        },
                                    },
                                ],
                                controlType: "CategoryFilter",
                                options: {
                                    filterColumnIndex: 0,
                                    ui: {
                                        labelStacking: "vertical",
                                        label: "Bolsa",
                                        allowTyping: false,
                                        allowMultiple: false,
                                    },
                                },
                            },
                        ]}
                    />

                </Tab>
                <Tab eventKey="Renovadas" title="Renovadas">

                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={dataFiltradoReno}
                        options={options}
                        formatters={formatters}
                        chartWrapperParams={{ view: { columns: [0, 1, 2, 3] } }}
                        chartPackages={["corechart", "controls"]}
                        controls={[
                            {
                                controlEvents: [
                                    {
                                        eventName: "statechange",
                                        callback: ({ chartWrapper, controlWrapper }) => {
                                            console.log("State changed to", controlWrapper?.getState());
                                        },
                                    },
                                ],
                                controlType: "CategoryFilter",
                                options: {
                                    filterColumnIndex: 0,
                                    ui: {
                                        labelStacking: "vertical",
                                        label: "Bolsa",
                                        allowTyping: false,
                                        allowMultiple: false,
                                    },
                                },
                            },
                        ]}
                    />

                </Tab>

            </Tabs>
        </div>
    )
};
export default Bolsas_pizza_detalhe;

